import { graphButtonsProps } from '@/graph/components/graphButtonsProps'
import { Flex, StyleProps } from '@chakra-ui/react'
import { GraphView } from '@rolebase/shared/model/graph'
import React, { ReactNode } from 'react'
import CirclesGraphSettingsMenu, {
  HighlightToggle,
} from './CirclesGraphSettingsMenu'
import GraphViewsSelect from './GraphViewsSelect'

interface CirclesGraphOptionsProps extends StyleProps {
  value: GraphView
  onChange: (value: GraphView) => void
  myRoles?: HighlightToggle
  vacantRoles?: HighlightToggle
  // Shown instead of the settings menu, which has nothing to offer there: the
  // save status of the whiteboard (#200)
  rightContent?: ReactNode
}

export default function CirclesGraphOptions({
  value,
  onChange,
  myRoles,
  vacantRoles,
  rightContent,
  ...styleProps
}: CirclesGraphOptionsProps) {
  return (
    <Flex justifyContent="space-between" {...styleProps}>
      <GraphViewsSelect
        value={value}
        onChange={onChange}
        whiteboardOption
        {...graphButtonsProps}
        fontWeight="bold"
      />

      {rightContent ?? (
        <CirclesGraphSettingsMenu myRoles={myRoles} vacantRoles={vacantRoles} />
      )}
    </Flex>
  )
}
